import { GDM } from "./helpers/datamanager";
import { DataTable } from "./loaders/stb";
import { StringTable } from "./loaders/stl";
import { ModelListManager } from "./datamanagers/modellistmanager";
import { SkeletonData } from "./loaders/zmd";
import { CharacterList } from "./loaders/chr";

/**
 * Register all character-related data resources with GDM.
 * Used by both the client and the editor.
 */
export function registerCharacterData() {
    GDM.register("char_motiontypes", DataTable, "3DDATA/STB/TYPE_MOTION.STB");
    GDM.register("char_motions", DataTable, "3DDATA/STB/FILE_MOTION.STB");

    GDM.register("male_skel", SkeletonData, "3DDATA/AVATAR/MALE.ZMD");
    GDM.register("female_skel", SkeletonData, "3DDATA/AVATAR/FEMALE.ZMD");
    GDM.register("castle_gear_skel", SkeletonData, "3DDATA/PAT/CASTLEGEAR/CASTLEGEAR02/CASTLEGEAR02.ZMD");
    GDM.register("cart_skel", SkeletonData, "3DDATA/PAT/CART/CART01.ZMD");

    GDM.register("itm_mface", ModelListManager, "3DDATA/AVATAR/LIST_MFACE.ZSC");
    GDM.register("itm_mhair", ModelListManager, "3DDATA/AVATAR/LIST_MHAIR.ZSC");
    GDM.register("itm_mcap", ModelListManager, "3DDATA/AVATAR/LIST_MCAP.ZSC");
    GDM.register("itm_mbody", ModelListManager, "3DDATA/AVATAR/LIST_MBODY.ZSC");
    GDM.register("itm_marms", ModelListManager, "3DDATA/AVATAR/LIST_MARMS.ZSC");
    GDM.register("itm_mfoot", ModelListManager, "3DDATA/AVATAR/LIST_MFOOT.ZSC");
    GDM.register("itm_mfaceitem", ModelListManager, "3DDATA/AVATAR/LIST_FACEIEM.ZSC");

    GDM.register("itm_fface", ModelListManager, "3DDATA/AVATAR/LIST_WFACE.ZSC");
    GDM.register("itm_fhair", ModelListManager, "3DDATA/AVATAR/LIST_WHAIR.ZSC");
    GDM.register("itm_fcap", ModelListManager, "3DDATA/AVATAR/LIST_WCAP.ZSC");
    GDM.register("itm_fbody", ModelListManager, "3DDATA/AVATAR/LIST_WBODY.ZSC");
    GDM.register("itm_farms", ModelListManager, "3DDATA/AVATAR/LIST_WARMS.ZSC");
    GDM.register("itm_ffoot", ModelListManager, "3DDATA/AVATAR/LIST_WFOOT.ZSC");
    GDM.register("itm_ffaceitem", ModelListManager, "3DDATA/AVATAR/LIST_FACEIEM.ZSC");

    GDM.register("itm_back", ModelListManager, "3DDATA/AVATAR/LIST_BACK.ZSC");
    GDM.register("itm_weapon", ModelListManager, "3DDATA/WEAPON/LIST_WEAPON.ZSC");
    GDM.register("itm_subwpn", ModelListManager, "3DDATA/WEAPON/LIST_SUBWPN.ZSC");

    // PAT (cart/castle-gear) part visuals. LIST_PAT.STB (the stats table,
    // already loaded separately as ItemDataManager's ITEMTYPE.RIDE_PART)
    // has a "model path" column pointing at a `.txt` file that doesn't
    // exist anywhere in this asset set -- verified empirically (Task 14):
    // no .txt files exist under 3DDATA at all, and the STB's path for
    // itemNo 5 ("Sporty Frame") resolves to a nonexistent
    // cart01_BODY03.txt. The real renderable models live in this ZSC,
    // indexed directly by itemNo exactly like itm_weapon/itm_back -- e.g.
    // models[5]/[103]/[201]/[700] reference the real CART01_BODY03*.ZMS/
    // ENGINE01*.ZMS/WHEEL01*.ZMS/WEAPON01.ZMS mesh files on disk.
    GDM.register("itm_pat", ModelListManager, "3DDATA/PAT/LIST_PAT.ZSC");

    // NPC data
    GDM.register("npc_chars", CharacterList, "3DDATA/NPC/LIST_NPC.CHR");
    GDM.register("npc_models", ModelListManager, "3DDATA/NPC/PART_NPC.ZSC");
    GDM.register("list_npc", DataTable, "3DDATA/STB/LIST_NPC.STB");
    GDM.register("list_sell", DataTable, "3DDATA/STB/LIST_SELL.STB");
    GDM.register("npc_names", StringTable, "3DDATA/STB/LIST_NPC_S.STL");
}
